import { render, staticRenderFns } from "./per-notifications.vue?vue&type=template&id=1197e342&scoped=true&lang=pug&"
import script from "./per-notifications.vue?vue&type=script&lang=js&"
export * from "./per-notifications.vue?vue&type=script&lang=js&"
import style0 from "./per-notifications.vue?vue&type=style&index=0&id=1197e342&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1197e342",
  null
  
)

export default component.exports